const R = require('ramda')
const mergeConfig = require('coact/config/mergeConfig')

const clientConfig = require('./clientConfig')


const config = R.assocPath(
  ['models', 'purchaseOrders', 'views', 'batch'],
  clientConfig,
  { },
)


module.exports = fullConfig => mergeConfig(fullConfig, config)
